import dynamic from 'next/dynamic';
import { SHORTHAND_COMPONENT_NAME } from '../constants';
export default {
  [SHORTHAND_COMPONENT_NAME]: dynamic(() => import(/* webpackChunkName: "blazePbShortHandStory" */'./ShorthandStory'))
};
//# sourceMappingURL=index.js.map